export default __webpack_public_path__ + "static/media/calf_instructions.afb81e10.mp3";